/*jshint esversion: 6 */
// or .jshintrc for all jsx-files
import React from 'react';

import { connect } from 'react-redux';
import { Dispatch } from "redux";

import * as THREE from 'three';

//import { OBJLoader } from "three/examples/jsm/loaders/OBJLoader";
import { STLLoader } from "three/examples/jsm/loaders/STLLoader";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { GLTF, GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

//import ktrlogo from './ktrlogo.png'

import { RootState } from '../../store/Store';
import { FlowState, updateFlowInputAction } from '../../store/reducers/FlowReducer'

import { getElementWithPagekey, getFlow } from '../../service/flowengine/FlowEngineAPI';
import { InputElement, InputOptional, InputType } from '../../service/flowengine/model/Element';

import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';


/*
const styles = theme => ({
    page: theme.aside.page,
    aside: theme.aside.aside,
    body: {
        ...theme.aside.body,
        minHeight: 'initial',
        height: 'calc(100% - 81px)',
    },
    canvas: {
        height: '100%',
        width: '100%',
    }
});
*/


// ---------------------------------------------------
// ---------------------------------------------------
// Properties
// ---------------------------------------------------
type Props = {
    material: string,
    helpbox?: any,

    // if modelnamedriving exists: take this name as model to load ...
    modelnamedriving?: string,

    // ... else take value of element "elementnamedriving" from page "pagekeydriving" as the modelname to load for driving side
    pagekeydriving?: string,
    elementnamedriving?: string,

    // if modelnamedriven exists: take this name as model to load ...
    modelnamedriven?: string,

    // ... else take value of element "elementnamedriven" from page "pagekeydriveb" as the modelname to load for driveb side
    pagekeydriven: string,
    elementnamedriven: string,
}

// we need two portions of properties to have interfaces/types for each redux-mapping-method (mapStateToProps/mapDispatchToProps)
type PropsStatic = {
    flow: any
}

type PropsHandler = {
    updateFlowInput(state: FlowState): any,
}


// ---------------------------------------------------
// ---------------------------------------------------
// REDUX store
// ---------------------------------------------------

// Map component-properties to redux-store parts (input is the state, we return the according properties)
// this is the way from redux-store to component-properties
function mapStateToProps(state: RootState): PropsStatic {
  return {
    flow: state.flow.flow,                   // combined state  
  };
}

// Map handler to redux-store actions and place these handler methods into the component-props
// this is the way from component-properties to redux-store (by initiating actions in the redux-store to update it's state)
const mapDispatchToProps = (dispatch: Dispatch): PropsHandler => ({
  updateFlowInput: (state: FlowState) => dispatch(updateFlowInputAction(state)),
});

// Concatenate the two property-type-portions to a single property-type to be used in the component-creation
type Model3DProps = Props & PropsStatic & PropsHandler;


/*
interface IProps {
    material: string,
    model: string,
    helpbox: any,
}
*/

interface IState {
    texture?: THREE.Texture,
    material?: THREE.Material,
    materialsLibrary: { [id: string] : THREE.Material },
    showActivateBanner: boolean,
    openSnackbar: boolean,
}

export enum Side {
    DRIVING = "DRIVING",
    DRIVEN = "DRIVEN",
}


// ====================================================================================================================================
class Model3DICEngineOverview extends React.Component<Model3DProps, IState> {
    scene: THREE.Scene;
    //container: any;
    camera: THREE.PerspectiveCamera;
    renderer: THREE.WebGLRenderer;
    meshBox: THREE.Mesh | undefined;
    displayedModelDriving: THREE.Group | undefined;
    displayedModelDriven: THREE.Group | undefined;

    rotateModel: boolean;

    private divRef: React.RefObject<HTMLDivElement>;

    //
    modelnamedriving: string = "";
    modelnamedriven: string = "";

    //
    messageSnackbar: string = "Nothing to say";

    // --------------------------------------------------------------------------------------------------------------------------------
    constructor(props: Model3DProps) {
        super(props);

        this.state = {
            texture: undefined,
            material: undefined,
            materialsLibrary: {},
            showActivateBanner: false,
            openSnackbar: false,
        }

        this.scene = new THREE.Scene();
        this.camera = new THREE.PerspectiveCamera();
        this.renderer = new THREE.WebGLRenderer();
        this.displayedModelDriving = undefined;
        this.displayedModelDriven = undefined;

        this.divRef = React.createRef<HTMLDivElement>();

        this.rotateModel = true;
    }

    // --------------------------------------------------------------------------------------------------------------------------------
    componentDidMount = () => {
        //this.loadTexture().then (
        //    t => this.setState( { texture: t as THREE.Texture } )
        //);

        let mLib = this.createMaterialsLibrary();
        this.setState( { materialsLibrary: mLib } );

        //if (this.state.texture !== null) {
            this.init();
        //}

    }

    // --------------------------------------------------------------------------------------------------------------------------------
    componentDidUpdate = () => {
        let newmodelnamedriving = "";
        let newmodelnamedriven = "";

        // driving
        // if property "modelnamedriving" is passed, take it as name of the model to load ...
        if(this.props.modelnamedriving !== undefined) {
            newmodelnamedriving = this.props.modelnamedriving;
        }
        // ... otherwise take the element with name "elementnamedriving" at page with name of property "pagekeydriving" and use it's value as modelname.
        else if(this.props.pagekeydriving !== undefined && this.props.elementnamedriving !== undefined) {
            // retrieve modelname by pagekey and elementname
            let e: InputElement | undefined = getElementWithPagekey(this.props.pagekeydriving, this.props.elementnamedriving);
            if(e !== undefined) {
                if(e.type !== InputType.Multiple) {
                    if(e.type === InputType.Optional)
                        newmodelnamedriving = (e as InputOptional).assets[e.value as number];
                    else
                        newmodelnamedriving = e.value as string;
                    //newmodelnamedriving = newmodelnamedriving.replace(/ /g,'');    // remove all spaces
                }
            }
        }

        // driven
        // if property "modelnamedriven" is passed, take it as name of the model to load ...
        if(this.props.modelnamedriven !== undefined) {
            newmodelnamedriven = this.props.modelnamedriven;
        }
        // ... otherwise take the element with name "elementnamedriven" at page with name of property "pagekeydriven" and use it's value as modelname.
        else if(this.props.pagekeydriven !== undefined && this.props.elementnamedriven !== undefined) {
            // retrieve modelname by pagekey and elementname
            let e: InputElement | undefined = getElementWithPagekey(this.props.pagekeydriven, this.props.elementnamedriven);
            if(e !== undefined) {
                if(e.type !== InputType.Multiple) {
                    if(e.type === InputType.Optional)
                        newmodelnamedriven = (e as InputOptional).assets[e.value as number];
                    else
                        newmodelnamedriven = e.value as string;
                    //newmodelnamedriven = newmodelnamedriven.replace(/ /g,'');    // remove all spaces
                }
            }
        }

        // DRIVING: modelname changed, so load new model:
        if(this.modelnamedriving !== newmodelnamedriving) {
            // remove old object:
            if(this.displayedModelDriving !== undefined) {
                this.scene.remove(this.displayedModelDriving);
                this.displayedModelDriving = undefined;
            }

            //
            //let materialName: string = this.props.material;
            this.modelnamedriving = newmodelnamedriving;

            // lets first try GLTF format (*.glb):
            //let pathToModel = process.env.PUBLIC_URL + "/models/" + this.modelnamedriving.toLowerCase() + ".glb";
            let pathToModel = process.env.PUBLIC_URL + "/models/" + this.modelnamedriving + ".glb";
            this.loadModel(pathToModel, Side.DRIVING);
        }

        // DRIVEN: modelname changed, so load new model:
        if(this.modelnamedriven !== newmodelnamedriven) {
            // remove old object:
            if(this.displayedModelDriven !== undefined) {
                this.scene.remove(this.displayedModelDriven);
                this.displayedModelDriven = undefined;
            }

            //
            //let materialName: string = this.props.material;
            this.modelnamedriven = newmodelnamedriven;

            // lets first try GLTF format (*.glb):
            //let pathToModel = process.env.PUBLIC_URL + "/models/" + this.modelnamedriven.toLowerCase() + ".glb";
            let pathToModel = process.env.PUBLIC_URL + "/models/" + this.modelnamedriven + ".glb";
            this.loadModel(pathToModel, Side.DRIVEN);
        }

    }

    // --------------------------------------------------------------------------------------------------------------------------------
    setBackground = () => {
        return new Promise(async (s, r) => {
            const textureLoader = new THREE.TextureLoader();
            var pathToTexture = process.env.PUBLIC_URL + "/images/Background.jpg";
            let t = await textureLoader.load(pathToTexture);
            this.scene.background = t;
            t.wrapS = THREE.MirroredRepeatWrapping;
            t.wrapT = THREE.MirroredRepeatWrapping;
        })
    }

    // --------------------------------------------------------------------------------------------------------------------------------
    loadTexture = () => {
        return new Promise(async (s, r) => {
            const textureLoader = new THREE.TextureLoader();
            var pathToTexture = process.env.PUBLIC_URL + "/models/sinter.jpg";
            let t = await textureLoader.load(pathToTexture);
            s(t)
        })
    }

    setTexture = (m: THREE.MeshBasicMaterial) => {
        const texture: THREE.Texture | undefined = this.state.texture;
        if(texture !== undefined) {
            texture.encoding = THREE.sRGBEncoding;
            texture.anisotropy = 16;
            m.map = texture;
        }
    }

    loadSTL = (pathToModel: string) => {
        var modelname = pathToModel.substring(pathToModel.lastIndexOf('/')+1);        
        this.messageSnackbar = "Loading 3D model [" + modelname + "]";
        this.setState( { openSnackbar: true } );

        return new Promise(resolve => {
          new STLLoader().load(pathToModel, resolve);
        });
    }

    loadModel = (pathToModel: string, side: Side) => {
        // we try to load GLTF (because if supports inherently colors etc.). If this fails, we try a STL file with same name !
        this.loadGLTF(pathToModel, side);
    }


    // ---
    loadGLTF = (pathToModel: string, side: Side) => {
        const loader = new GLTFLoader();
        const onLoad = ( gltf: GLTF, position: THREE.Vector3) => {
            //const model = gltf.scene.children[ 0 ];
            //model.position.copy(position);

            if(side === Side.DRIVING) {
                this.displayedModelDriving = gltf.scene;

                //this.displayedModelDriving.scale(new THREE.Vector3(10.0, 10.0, 10.0));

                this.scene.add(this.displayedModelDriving);
            }
            else if(side === Side.DRIVEN) {
                this.displayedModelDriven = gltf.scene;

                //this.displayedModelDriven.rotation.x = -Math.PI/2.0;
                this.displayedModelDriven.position.z -= 200.0;
                this.displayedModelDriven.rotation.y = Math.PI/1.0;
                
                this.scene.add(this.displayedModelDriven);
            }
            else
                return;
        };
     
        // Ladefortschritt:
        const onProgress = (message: ProgressEvent) => { 
            //console.log("Loading GLB: " + pathToModel + " total=" + message.total + " , loaded= " + message.loaded + ", target=" + message.target); 
        };
     
        // Fehlermeldung an Console
        const onError = ( errorMessage: any ) => { 
            // Error, so we try to load STL instead:
            console.log( errorMessage ); 

            // if no gltf: try stl:
            if(side === Side.DRIVING)
                //pathToModel = process.env.PUBLIC_URL + "/models/" + this.modelnamedriving.toLowerCase() + ".stl";
                pathToModel = process.env.PUBLIC_URL + "/models/" + this.modelnamedriving + ".stl";
            else
                //pathToModel = process.env.PUBLIC_URL + "/models/" + this.modelnamedriven.toLowerCase() + ".stl";
                pathToModel = process.env.PUBLIC_URL + "/models/" + this.modelnamedriven + ".stl";

            this.loadSTL(pathToModel).then(geometry => {
                    let materialName: string = this.props.material;  // overdraws color ???

                    if(side === Side.DRIVING) {
                        materialName = "Chrome";  // overwrite  material for motor
                        this.displayedModelDriving = new THREE.Group().add(new THREE.Mesh(geometry as any, this.state.materialsLibrary[materialName]));
                        //this.displayedModelDriving = new THREE.Group().add(new THREE.Mesh(geometry as any));
                        this.displayedModelDriving.rotation.x = -Math.PI/2.0;
                        this.scene.add(this.displayedModelDriving);
                    }
                    else if(side === Side.DRIVEN) {
                        materialName = "Blue metal";  // overwrite  material for motor
                        this.displayedModelDriven = new THREE.Group().add(new THREE.Mesh(geometry as any, this.state.materialsLibrary[materialName]));

                        this.displayedModelDriven.rotation.x = -Math.PI/2.0;
                        this.displayedModelDriven.position.z -= 200.0;
                        this.displayedModelDriven.rotation.z = Math.PI/1.0;
                        //this.displayedModelDriven.rotation.y += Math.PI/2.0;
        
                        this.scene.add(this.displayedModelDriven);
                    }
                    else
                        return;
            
                    // after load: close snackbar:
                    this.setState( { openSnackbar: false } );
                }
            );

        };
     
        // Modell asynchron laden. 
        const modelPosition = new THREE.Vector3( 0, 0, 0 );
        loader.load( pathToModel, gltf => onLoad( gltf, modelPosition ), onProgress, onError );
    
        //
        var modelname = pathToModel.substring(pathToModel.lastIndexOf('/')+1);        
        this.messageSnackbar = "Loading 3D model [" + modelname + "]";
        this.setState( { openSnackbar: true } );
    }

    //loadOBJ = (pathToModel: string) => {
    //    return new Promise(resolve => {
    //      new OBJLoader().load(pathToModel, resolve);
    //    });
    //}

    // --------------------------------------------------------------------------------------------------------------------------------
    createCoordSystem = () => {
      var axis = new THREE.AxesHelper(200);
      this.scene.add(axis);
    }

    // -------------------------------------------------------------------------------------------------
    createBottomPlane = () => {
      var grid = new THREE.GridHelper(10000.0, 500.0, 0xffffff, 0xaaaaaa);
      this.scene.add(grid);
    }

    // --------------------------------------------------------------------------------------------------------------------------------
    createMaterialsLibrary = () => {
        var mlib: { [id: string] : THREE.Material } = {};

        mlib["Hidden Line"]     = new THREE.MeshBasicMaterial( { color: 0xff6600,  } );
        mlib["Simple Green"]    = new THREE.MeshBasicMaterial( { color: 0x00aa00,  } );
        mlib["Simple Red"]      = new THREE.MeshBasicMaterial( { color: 0xaa0000,  } );
        mlib["Simple Blue"]     = new THREE.MeshBasicMaterial( { color: 0x0000aa,  } );
        mlib["Orange"]  	    = new THREE.MeshLambertMaterial( { color: 0xff6600, emissive: 0xff2200, combine: THREE.MixOperation, reflectivity: 0.3 } );
        mlib["Blue"]            = new THREE.MeshLambertMaterial( { color: 0x001133, emissive: 0x001133, combine: THREE.MixOperation, reflectivity: 0.3 } );
        mlib["Red"]             = new THREE.MeshLambertMaterial( { color: 0x660000, emissive: 0x330000, combine: THREE.MixOperation, reflectivity: 0.25 } );
        mlib["Black"]           = new THREE.MeshLambertMaterial( { color: 0x000000, emissive: 0x000000, combine: THREE.MixOperation, reflectivity: 0.15 } );
        mlib["White"]           = new THREE.MeshLambertMaterial( { color: 0xffffff, emissive: 0x666666, combine: THREE.MixOperation, reflectivity: 0.25 } );
        mlib["Carmine"]         = new THREE.MeshPhongMaterial( { color: 0x770000, specular:0xffaaaa, combine: THREE.MultiplyOperation } );
        mlib["Gold"]            = new THREE.MeshPhongMaterial( { color: 0xaa9944, specular:0xbbaa99, shininess:50, combine: THREE.MultiplyOperation } );
        mlib["Bronze"]          = new THREE.MeshPhongMaterial( { color: 0x150505, specular:0xee6600, shininess:10, combine: THREE.MixOperation, reflectivity: 0.25 } );

        //mlib["Copper"]          = new THREE.MeshPhongMaterial( { color: 0xE6C2AB, specular:0xee6600, shininess:10, combine: THREE.MixOperation, reflectivity: 0.25 } );
        //mlib["Copper"]          = new THREE.MeshPhongMaterial( { color: 0xB49189, specular:0xee6600, shininess:10, combine: THREE.MixOperation, reflectivity: 0.25 } );
        //mlib["Copper"]          = new THREE.MeshPhongMaterial( { color: 0xB49189, specular:0xee6600, shininess:5, combine: THREE.MixOperation, reflectivity: 0.15} );
        mlib["Copper"]          = new THREE.MeshPhongMaterial( { color: 0xEBB2A5, specular:0xee6600, shininess:10, combine: THREE.MixOperation, reflectivity: 0.25 } );
        //mlib["Texture"]         = new THREE.MeshStandardMaterial( {map: this.state.texture, } );

        mlib["Chrome"]          = new THREE.MeshPhongMaterial( { color: 0xffffff, specular:0xffffff, combine: THREE.MultiplyOperation } );
        mlib["Orange metal"]    = new THREE.MeshLambertMaterial( { color: 0xff6600, emissive: 0xff2200, combine: THREE.MultiplyOperation } );
        mlib["Blue metal"]      = new THREE.MeshLambertMaterial( { color: 0x001133, emissive: 0x002266, combine: THREE.MultiplyOperation } );
        mlib["Red metal"]       = new THREE.MeshLambertMaterial( { color: 0x770000, combine: THREE.MultiplyOperation } );
        mlib["Green metal"]     = new THREE.MeshLambertMaterial( { color: 0x007711, combine: THREE.MultiplyOperation } );
        mlib["Black metal"]     = new THREE.MeshLambertMaterial( { color: 0x222222, combine: THREE.MultiplyOperation } );
        mlib["Pure chrome"]     = new THREE.MeshLambertMaterial( { color: 0xffffff } );
        mlib["Dark chrome"]     = new THREE.MeshLambertMaterial( { color: 0x444444 } );
        mlib["Darker chrome"]   = new THREE.MeshLambertMaterial( { color: 0x222222 } );
        mlib["Black glass"]     = new THREE.MeshLambertMaterial( { color: 0x101016, opacity: 0.975, transparent: true } );
        mlib["Dark glass"]      = new THREE.MeshLambertMaterial( { color: 0x101046, opacity: 0.25, transparent: true } );
        mlib["Blue glass"]      = new THREE.MeshLambertMaterial( { color: 0x668899, opacity: 0.75, transparent: true } );
        mlib["Light glass"]     = new THREE.MeshBasicMaterial( { color: 0x223344, opacity: 0.25, transparent: true, combine: THREE.MixOperation, reflectivity: 0.25 } );
        mlib["Red glass"]       = new THREE.MeshLambertMaterial( { color: 0xff0000, opacity: 0.75, transparent: true } );
        mlib["Yellow glass"]    = new THREE.MeshLambertMaterial( { color: 0xffffaa, opacity: 0.75, transparent: true } );
        mlib["Orange glass"]    = new THREE.MeshLambertMaterial( { color: 0x995500, opacity: 0.75, transparent: true } );
        mlib["Orange glass 50"] = new THREE.MeshLambertMaterial( { color: 0xffbb00, opacity: 0.5, transparent: true } );
        mlib["Red glass 50"]    = new THREE.MeshLambertMaterial( { color: 0xff0000, opacity: 0.5, transparent: true } );
        mlib["Fullblack rough"] = new THREE.MeshLambertMaterial( { color: 0x000000 } );
        mlib["Black rough"]     = new THREE.MeshLambertMaterial( { color: 0x050505 } );
        mlib["Darkgray rough"]  = new THREE.MeshLambertMaterial( { color: 0x090909 } );
        mlib["Red rough"]       = new THREE.MeshLambertMaterial( { color: 0x330500 } );
        mlib["Darkgray shiny"]  = new THREE.MeshPhongMaterial( { color: 0x000000, specular: 0x050505 } );
        mlib["Gray shiny"]      = new THREE.MeshPhongMaterial( { color: 0x050505, shininess: 20 } );

        mlib["STLWithColors"]   = new THREE.MeshPhongMaterial({ vertexColors: true });

        return mlib;
    }

    createLights = () => {
        let light = new THREE.DirectionalLight(0xffffff, 0.5);
        light.position.set(-100, -100, -100);
        //this.scene.add(light);

        let light1 = new THREE.DirectionalLight(0xaaaaaa);
        light.position.set(-100, -100, -100);
        //this.scene.add(light1);

        let light2 = new THREE.AmbientLight(0x222222, 1.0);
        this.scene.add(light2);

        const light3 = new THREE.DirectionalLight(0xffffff, 1.5);
        light3.position.set(100, 100, 100);
        this.scene.add(light3);
    }

    createTestBoxAndTextureAndLight = () => {
        // --------------------------------------------------------------
        // TEST START
        const geometry = new THREE.BoxBufferGeometry(100, 100, 100);
        const texture: THREE.Texture | undefined = this.state.texture;
        if(texture !== undefined) {
            texture.encoding = THREE.sRGBEncoding;
            texture.anisotropy = 16;
            const m = new THREE.MeshStandardMaterial( {
                map: texture,
            } );
            this.meshBox = new THREE.Mesh(geometry, m);

            //this.setState({ material: m });  // init will be called in componentWillUpdate which will be called when setState happens: inifite loop !!!

            //
            //const light = new THREE.DirectionalLight(0xffffff, 5.0);
            //light.position.set(10, 10, 10);
            //scene.add(light);

            this.scene.add(this.meshBox);
        }
        // TEST END
    }


    // ------------------------------------------------------------------------------------
    makeTextSprite = (message: any, parameters: any): any => {
        if (parameters === undefined) 
            parameters = {};
        
        var fontface = parameters.hasOwnProperty("fontface") ? parameters["fontface"] : "Arial";
        var fontsize = parameters.hasOwnProperty("fontsize") ? parameters["fontsize"] : 18;
        var borderThickness = parameters.hasOwnProperty("borderThickness") ? parameters["borderThickness"] : 3;
        var borderColor = parameters.hasOwnProperty("borderColor") ? parameters["borderColor"] : { r:255, g:255, b:255, a: 0.5 /*1.0*/ };
        var backgroundColor = parameters.hasOwnProperty("backgroundColor") ? parameters["backgroundColor"] : { r:255, g:255, b:255, a:1.0 };

        var canvas = document.createElement('canvas');
        canvas.height = 400;      // !!!!! sonst ist "Pfeil" abgeschnitten, zu verfeinern
        //canvas.width = 1000;
        var context = canvas.getContext('2d');
        if(context === null) return null;

        //canvas.height = 400;      // !!!!! sonst ist "Pfeil" abgeschnitten, zu verfeinern
        context.font = "Bold " + fontsize + "px " + fontface;


        
        // get size data (height depends only on font size)
        var metrics = context.measureText( message );
        var textWidth = metrics.width * 1.5;
        
        // background color
        context.fillStyle   = "rgba(" + backgroundColor.r + "," + backgroundColor.g + ","  + backgroundColor.b + "," + backgroundColor.a + ")";
        // border color
        context.strokeStyle = "rgba(" + borderColor.r + "," + borderColor.g + "," + borderColor.b + "," + borderColor.a + ")";

        context.lineWidth = borderThickness;
        this.roundRect(context, borderThickness/2, borderThickness/2, textWidth + (borderThickness*4), fontsize * 1.4 + borderThickness, 6);
        this.arrowTriangle(context, borderThickness/2, borderThickness/2, textWidth + (borderThickness*4), fontsize * 1.4 + borderThickness, 6);


        // 1.4 is extra height factor for text below baseline: g,j,p,q.
        
        // text color
        context.fillStyle = "rgba(0, 0, 0, 1.0)";
        context.fillText(message, borderThickness, fontsize + borderThickness);
        
        // canvas contents will be used for a texture
        var texture = new THREE.Texture(canvas) 
        texture.needsUpdate = true;

        var spriteMaterial: THREE.SpriteMaterial = new THREE.SpriteMaterial( { map: texture } );
        var sprite: THREE.Sprite = new THREE.Sprite(spriteMaterial);
        sprite.scale.set(300, 100, 1.0);

        return sprite;	
    }


    arrowTriangle = (ctx: any, x: number, y: number, w: number, h: number, r:number) => {
        ctx.beginPath();

        var t = w/9.0
        ctx.moveTo(x+t, y+h);
        ctx.lineTo(150.0, 400.0);    // arrow target
        ctx.lineTo(x, y+h);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
    }



    // function for drawing rounded rectangles
    roundRect = (ctx: any, x: number, y: number, w: number, h: number, r:number) => {
        ctx.beginPath();

        ctx.moveTo(x, y);
        ctx.lineTo(x+w, y);
        ctx.lineTo(x+w, y+h);
        ctx.lineTo(x, y+h);

        ctx.closePath();
        ctx.fill();
        ctx.stroke();

        /*
        ctx.beginPath();
        ctx.moveTo(x+r, y);
        ctx.lineTo(x+w-r, y);
        ctx.quadraticCurveTo(x+w, y, x+w, y+r);
        ctx.lineTo(x+w, y+h-r);
        ctx.quadraticCurveTo(x+w, y+h, x+w-r, y+h);
        ctx.lineTo(x+r, y+h);
        ctx.quadraticCurveTo(x, y+h, x, y+h-r);
        ctx.lineTo(x, y+r);
        ctx.quadraticCurveTo(x, y, x+r, y);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
        */
    }


    // --------------------------------------------------------------------------------------------------------------------------------
    init = () => {
        // --------------------------------------------------------------
        this.scene.background = new THREE.Color(0xF0F0F0);
        this.setBackground();

// -#-verhaut das hier die groesse ???

        let w = window.innerWidth;
        let h = window.innerHeight;
        if(this.divRef.current != null) {
          w = this.divRef.current?.clientWidth;
          //h = this.divRef.current?.clientHeight;
          h = this.divRef.current?.clientWidth/3.0;      // ugly !!!
        }

        const fov = 35;
        const aspect = w / h;
        const near = 0.1;
        const far = 10000;

        // --------------------------------------------------------------
        this.camera = new THREE.PerspectiveCamera(fov, aspect, near, far);
        this.camera.position.x = 1600;   // 1255;  // 0;
        this.camera.position.y = 1000;   // 568;   // 300;
        this.camera.position.z = 800;   // 789;   // 1800;
        this.camera.up.x = 0;
        this.camera.up.y = 1;
        this.camera.up.z = 0;
        this.camera.lookAt(new THREE.Vector3(0, 0, 0));


        // --------------------------------------------------------------
        // TEST TEST TEST
        //this.createTestBoxAndTextureAndLight();

        // --------------------------------------------------------------
        this.createLights();

        // --------------------------------------------------------------
        //let materialName: string = this.props.material;
        //let modelName: string = this.props.model;
        
        //let pathToModel = process.env.PUBLIC_URL + "/models/" + modelName.toLowerCase() + ".stl";

/*
        //this.loadModel(pathToModel, this.state.materialsLibrary[materialName], 'STL');
        this.loadSTL(pathToModel).then(geometry => {
                this.displayedModel = new THREE.Mesh(geometry as any, this.state.materialsLibrary[materialName]);
                //this.setTexture(this.displayedModel.material as THREE.MeshBasicMaterial);
                this.scene.add(this.displayedModel);

                // const texture: THREE.Texture | undefined = this.state.texture;
                // if(texture !== undefined) {
                //     texture.encoding = THREE.sRGBEncoding;
                //     texture.anisotropy = 16;
                //
                //     var m = new THREE.MeshPhongMaterial( {
                //         map: texture,
                //         color: Math.random() * 0xffffff
                //     } );
                //     let mesh = new THREE.Mesh(geometry as any, m);
                //
                //     this.scene.add(mesh);
                // }
                // else {
                //     let mesh = new THREE.Mesh(geometry as any, this.state.materialsLibrary[materialName]);
                //     this.scene.add(mesh);
                // }
            }
        );
*/

        // --------------------------------------------------------------
        this.createCoordSystem();
        //this.createBottomPlane();

        // --------------------------------------------------------------
        this.renderer.setSize(w, h );
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setClearColor(0xffffff, 1.0);
        this.divRef.current?.appendChild(this.renderer.domElement);

        // --------------------------------------------------------------
        var controls = new OrbitControls(this.camera, this.renderer.domElement);
        controls.addEventListener('change', this.orbitalControlsChangeEventHandler);

        // --------------------------------------------------------------
        // TEST TEST TEST TEST
        //var spriteMassText: any = this.makeTextSprite("Zu tun ...", { fontsize: 96, backgroundColor: {r:255, g:255, b:255, a: 0.5  /*1.0 */} } );
        //spriteMassText.position.set(0.0, 150.0, -250.0);
        //this.scene.add(spriteMassText);

        // --------------------------------------------------------------
        this.renderer.setAnimationLoop( () => {
            //this.update();
            this.render3D();
        })
    }

    orbitalControlsChangeEventHandler = () => {
        this.rotateModel = false;
    }

    update = () => {
        /*
        if(this.displayedModel !== undefined && this.rotateModel === true) {
            //this.displayedModel.rotation.z += 0.01;
            //this.displayedModel.rotation.x += 0.01;
            this.displayedModel.rotation.y += 0.01;
        }
        */
    }
    
    render3D = () => {
        this.renderer.render(this.scene, this.camera);
    }

    handleOnMouseEnter = (e:any) => {
        this.setState( { showActivateBanner: false } );
    }
    
    handleClose = (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
        if (reason === 'clickaway') {
          return;
        }
    
        this.setState( { openSnackbar: false } );
      };
    

    // --------------------------------------------------------------------------------------------------------------------------------
    render = () => {
        if(getFlow().name !== "icengine") // show 3D only when target is icengine
            return "";
        else {
            return (
                <span >
{/*             <div style={{display: "inline", position: "relative", width: "400px", height: "400px"}}>   */}

                    <div style={{outline: "none"}} ref={this.divRef} onMouseEnter={this.handleOnMouseEnter}></div>

{/*
                    {this.props.helpbox !== undefined ?
                        <div style={{display: "inline-block", position: "absolute", bottom: "0", left: "0", color: "white"}}>
                            {this.props.helpbox}
                        </div>
                        : ""
                    }
*/}

{/*
                    <div style={{position: "absolute", top: "0", right: "0"}}>
                        <img src={ktrlogo} alt="KTR" />
                    </div>
*/}                

{/*
                    <div style={{display: "inline-block", position: "absolute", top: "0", right: "0"}}>
                        <img src={ktrlogo} alt="KTR" />
                    </div>
*/}

{/*
                    {this.state.showActivateBanner === true ?
                        <div onMouseEnter={this.handleOnMouseEnter} style={{position: "absolute", top:"40%", left:"13%", color: "#F29400", fontSize: "36px", fontWeight:"bold", zIndex:100}}>
                            Click here to activate
                        </div>
                        : ""
                    }
*/}

                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',

                    }}
                    open={this.state.openSnackbar}
                    autoHideDuration={6000}
                    onClose={this.handleClose}
                    message={this.messageSnackbar}
                    action={
                        <React.Fragment>
                            {/*
                            <Button color="secondary" size="small" onClick={this.handleClose}>
                                Dismiss
                            </Button>
                            */}
                            <IconButton size="small" aria-label="close" color="inherit" onClick={this.handleClose}>
                            <CloseIcon fontSize="small" />
                            </IconButton>
                        </React.Fragment>
                    }
                    
                />            
                </span>
            )
        }
    }    
}

//export default withStyles(styles)(Model3DICEngineOverview);
export default connect(mapStateToProps, mapDispatchToProps)(Model3DICEngineOverview);
